import { TabContainerProps } from './TabContainer.types';

export function firstVisibleIndexOrZero(tabs: TabContainerProps['tabs'], isLeftColumn: boolean) {
  // In the right column, there are no hidden tabs so 0 is always the first one visible
  if (!isLeftColumn) {
    return 0;
  }

  // In the left column, we have to search for the first visible tab in case 0 is hidden
  const index = tabs.findIndex((tab) => tab.column === 'left');

  return index === -1 ? 0 : index;
}

export function getTabIndex(tabs: TabContainerProps['tabs'], isLeftColumn: boolean, title?: string | null) {
  if (title) {
    const index = tabs.findIndex((tab) => tab.title === title);
    return index === -1 ? firstVisibleIndexOrZero(tabs, isLeftColumn) : index;
  }

  return firstVisibleIndexOrZero(tabs, isLeftColumn);
}
